import * as React from "react";

export type AsChildProps = {
  asChild?: boolean;
};

function inferNativeButton<TRender>({
  asChild,
  children,
  nativeButton,
  render,
}: {
  asChild?: boolean;
  children?: React.ReactNode;
  nativeButton?: boolean;
  render?: TRender;
}) {
  if (nativeButton !== undefined) return nativeButton;
  if (asChild) {
    return React.isValidElement(children) ? children.type === "button" : false;
  }
  if (React.isValidElement(render)) return render.type === "button";
  return undefined;
}

/**
 * Resolve the component-level `asChild` shorthand to Base UI's `render` prop.
 * Hiive components own this shorthand so call sites share one composition API
 * even when their underlying primitive comes from a different library.
 */
export function resolveRenderProp<TRender>({
  asChild,
  children,
  nativeButton,
  render,
}: {
  asChild?: boolean;
  children?: React.ReactNode;
  nativeButton?: boolean;
  render?: TRender;
}) {
  const resolvedNativeButton = inferNativeButton({
    asChild,
    children,
    nativeButton,
    render,
  });

  if (
    !render &&
    asChild &&
    React.isValidElement<{ children?: React.ReactNode }>(children)
  ) {
    return {
      children: children.props.children,
      nativeButton: resolvedNativeButton,
      render: children,
    };
  }

  return { children, nativeButton: resolvedNativeButton, render };
}
